module.exports = __webpack_public_path__ + "img/mb_hm_block03_04_tc.4449440a.png";